<template>
  <!---->
  <div class="d-flex align-items-center justify-content-center">
    <img v-if="!showIcon" style="max-width:100%; max-height:100%;"
      @click="$emit('imgClicked')" :src="getImageUrl() +'&rdmNum=' + rdmNum" />
    <i v-if="showIcon" style="color:grey;" class="fas" :class="icona"></i>
  </div>
</template>

<script>
import { ref } from '@/components/puntatori'

export default {
  name: 'ImageLoader',
  props: ['imgInfo', 'options', 'uploadTask'],
  computed: {},
  directives: {},
  data () {
    return {
      rdmNum: 0
      // VARIABILI AMBIENTE
    }
  },
  computed: {
    showIcon() {
      if (this.imgInfo.img_name === undefined) {
        return true;
      } else return false;
    },
    icona() {
      switch (this.imgInfo.tipo) {
        case "display":
          return "fa-mobile";
          break;
        case "battery":
          return "fa-battery-quarter";
          break;
        case "dock":
          return "fa-bolt";
          break;
        case "loud":
          return "fas fa-volume-up";
          break;
        case "ear":
          return "fas fa-volume-up";
          break;
        case "other":
          return "fa-question";
          break;
      }
    }
  },
  methods: {
    getImageUrl () {
      var oggetto = this.imgInfo
      if (oggetto.img_name !== undefined) {
        let estensione = oggetto.img_name.substr(
          oggetto.img_name.length - 4,
          4
        )
        let img_name = oggetto.img_name.substr(0, oggetto.img_name.length - 4)
        if (oggetto.img_name !== null) {
          if (oggetto.fonte === 'interno' && estensione === '.ext') {
            return (
              ref.urlBucketEsterno +
              oggetto.parent +
              '%2F' +
              img_name +
              '?alt=media'
            )
          }
        }
        if (oggetto.fonte === 'interno') {
          return (
            ref.urlBucket +
            oggetto.parent +
            '%2F' +
            oggetto.img_name +
            '?alt=media'
          )
        }
        if (oggetto.fonte === 'esterno') {
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            '%2F' +
            oggetto.img_name +
            '?alt=media'
          )
        }
      } else console.log('imageLoader.img_name non definito.')
    },
    changeImg () {
      var oggetto = this.imgInfo
    }
  },
  watch: {
    uploadTask () {
      var self = this
      this.uploadTask.then(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          if(url.includes(self.imgInfo.id)){
            this.rdmNum= Math.random()
           }
        })
      })
    }
  }
}
</script>

<style scoped >
.jContainer{
  position: relative;
}

.jContainer:hover .editButton{
  display: inline;
}

img{
  display:block;
  margin-left:auto;
  margin-right:auto;
}

.editButton{
  position: absolute;
  display:none;
  top: 10;
  right:90;
}
</style>
